import { httpClient, Service } from "./client";

class TagService extends Service {
  getAssetTags() {
    return httpClient.get("/tags/assetTags", this.authHeader());
  }
}

export const tagService = new TagService();
